// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__llRVr","content":"LayoutSettings_content__1apGD"};